<template>
	<div>
	    <header class="lmy-header lmy-header-w" >
	        <!-- <i class="iconfont icon-yuyin" @click="routetokPage('/')"></i> -->
	      <i class="iconfont icon-yuyin" onclick="window.history.go(-1)"></i>

	            龙猫抢购
	    </header>
		<!-- <div class="assist"></div> -->
			<!-- <div class="groupsbox lmy-filter-bar groupsbox-bar">
              <ul class="groupsbox-list" :style="'margin:.2rem 0 ;width:'+(activeGroups.length * 1.8)+'rem'">
                <li :class="activeGroupsItem==item.value?'list-item active':'list-item'" v-for="item in activeGroups" :key="item.value" @click="activeGroupsFoo(item)">{{item.lable}}</li>
              </ul>
            </div> -->
	    <div class="lmy-flash top-margin activeList" style="padding-top:1rem">

			<div class="lmy-new-search">
              <div class="search-box">
                  <div class="input-box">
                      <input type="text" v-model="presaleName" placeholder="请输入搜索关键字">
                  </div>
                  <span class="search-btn" @click="changeFilter">
                    <svg class="icon" aria-hidden="true">
                        <use xlink:href="#icon-sousuo"></use>
                    </svg>
                  </span>
              </div>
            </div>
			
	        <div class="flash-content" v-for="item in list" @click="$router.push('/presaleDetails?fromList=true&id='+item.ID);">
	            <div class="flash-figure">
	                <p>{{item.City}}</p>
                    <!-- <p class="high-Rebate-price" v-if="item.Rebate">立即返佣￥{{item.Rebate}}</p> -->
	                <img class="product-img" v-if="item.Img" :src="item.Img | replaceImgSrc(12)" alt="">
	                <img class="product-img" v-else src="./../../assets/img/hotelDetailsDf.png" alt="">
	                <!-- <div class="detonation">
	                    <img src="./../../assets/img/hot.png" alt="">
	                </div> -->
	            </div>

	             <div class="flash-sum-a">
	                 
	                 <div class="only">
						 <div>
							<p class="newPrice">￥{{item.SalePrice}}</p>
							<!-- <p class="oldPrice">市场价￥{{item.MarketPrice}}</p> -->
						</div>
						<div v-if="dateIntervene(item.Start)<=0">
							<span class="on">距结束:</span>
							<span class="under" v-html="item.clockEnd"></span>
						</div>
						<div v-if="dateIntervene(item.Start)>0">
							<p class="on">距开始:</p>
							<p class="under" v-html="item.clockStart"></p>
						</div>
	                 </div>
					 <div class="info">
	                     <p>{{item.Name}}</p>
	                 </div>
	             </div>

	        </div>

	    </div>
	   	<infinite-loading @infinite="initData" ref="infiniteLoading">
		    <span slot="no-more">
		     没有更多产品了...
		    </span>
		    <span slot="no-results" >
		     暂时没有相关产品...
		    </span>
		</infinite-loading>

	</div>
</template>
<script >
	import InfiniteLoading from 'vue-infinite-loading';
	export default{
		name:'activity-list',
		components:{
			InfiniteLoading
		},
		data(){
			return{
				list:[],
				Page:1,
				PageSize:10,
				total:0,
				presaleName: this.$route.query.key||''
				// activeGroups:[
                //     {lable:'全部',value:''},
                //     {lable:'防护用品',value:'2'},
                //     {lable:'生猛海鲜',value:'3'},
                //     {lable:'超值好货',value:'4'},
                //     {lable:'名鸡靓鸭',value:'5'},
                //     {lable:'精美熟食',value:'6'},
                //     {lable:'度假抢购',value:'1'},

                // ],
                // activeGroupsItem:''

			}
		},
		activated(){
            if(this.$route.query.key !=this.presaleName){
                this.presaleName=this.$route.query.key||'';
                this.changeFilter()
            }
        },
		methods:{
			// 活动类目
            // activeGroupsFoo(item){
            //     this.activeGroupsItem=item.value
            //     this.changeFilter()
			// },
			//条件更新后重置参数和结果
 			changeFilter($state) {

	 			this.Page=1;
	 			this.total=0;
				this.list=[]; 
		      	this.$nextTick(() => {
		      	    this.$refs.infiniteLoading.$emit('$InfiniteLoading:reset');
		      	});
		    },
			initClock(list){
				for(var i=0;i<list.length;i++){
					this.timeLoop(list[i],list[i].Start,list[i].End);
				}

			},
			timeLoop(item,start,end){

				var num=1;
				var that=this;
				var end=that.dateIntervene(end);
				var start=that.dateIntervene(start);
				var time=setInterval(function(){
					num++;
					if(num>=end){
						clearInterval(time);
					}else{
						that.$nextTick(function () {
							that.$set(item,'clockEnd',that.betDateFomate(end-num));
							that.$set(item,'clockStart',that.betDateFomate(start-num));
						});
					}
				},1000)
			},
			dateIntervene(date){
				var s1=new Date().getTime();
				var s2=new Date(date).getTime();
				return parseInt(((s2-s1>0)?(s2-s1):0)/1000);
			},
			betDateFomate(time){
	            var d,h,m,s;
	            if (time>=0) {
	                d = Math.floor(time/60/60/24);
	                h = Math.floor(time/60/60%24);
	                m = Math.floor(time/60%60);
	                s = Math.floor(time%60);
	            }

	            var intv='<span>'+d+'</span> 天 <span>'+(h<10?'0'+h:h)+'</span> 小时 <span>'+(m<10?'0'+m:m)+'</span> 分 <span>'+(s<10?'0'+s:s)+'</span> 秒 ';


				return intv;


			},
			initData($state){
				if(this.total>0&&(((this.Page-1)*this.PageSize)>this.total)){
					$state.complete();
					return;
				}
				var that=this;
				var params={
					Page:that.Page,
					PageSize:that.PageSize,
					Str: that.presaleName
					// Category:this.activeGroupsItem
				}
				that.postRequest({
		            url: that.Api.getPreSaleList,
		            params: params
		        }).then(res => {

					if (res&&res.IsSuccess&&res.Result.length>0) {
						that.total=res.Total;
						that.Page++;
						that.list = that.list.concat(res.Result);
						that.initClock(res.Result);

				        $state.loaded();

				    } else {
			            $state.complete();
			        }
		        });
			},
			routeToDetails(){

			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/activity/list.vue